export default {
  data: () => ({
    auth: {
      user_role: null,
      user_id: null,
    },
  }),

  computed: {
    isAdmin() {
      return this.auth.user_role === 'Account Admin';
    },
  },

  methods: {
    canDeleteBooking() {
      return this.isAdmin || ['Venue Manager'].includes(this.auth.user_role);
    },
    canUpdateBooking(booking) {
      return (this.canDeleteBooking()) ? true : (booking.user_id === this.auth.user_id);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/permission-mixins.js